import { render, staticRenderFns } from "./ErrorReport.vue?vue&type=template&id=66d1e77a&scoped=true"
import script from "./ErrorReport.vue?vue&type=script&lang=js"
export * from "./ErrorReport.vue?vue&type=script&lang=js"
import style0 from "./ErrorReport.vue?vue&type=style&index=0&id=66d1e77a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d1e77a",
  null
  
)

export default component.exports